import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../exo/ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewSalesLevel = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesObjectId,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const defaultStartData = {
    ...startData,
    reminderDaysAfter: startData?.reminderDaysAfter ?? '7',
  };

  const fields = [
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      label: t('Sales level'),
      type: 'number',
      key: 'accessLevel',
      decimalPlaces: 0,
    },
    {
      label: t('Hide the content of this level at higher levels'),
      key: 'hideAtHigherLevels',
      type: 'checkbox',
    },
    {
      label: t('Automatic E-Mail'),
      type: 'expandFields',
      fields: [
        {
          label: t(
            'Should an e-mail be sent automatically when an interested party is assigned to this level?'
          ),
          key: 'sendEmail',
          type: 'checkbox',
        },
        {
          label: t('Subject'),
          key: 'emailSubject',
          type: 'text',
        },
        {
          label: t('Attachments'),
          key: 'emailAttachments',
          type: 'images',
          maxItems: 10,
          maxSizeKB: 5000,
        },
        {
          label: t('Content'),
          key: 'emailContent',
          type: 'richTextEditor',
          textBlockType: 'block',
          allowSignature: true,
          signatureKey: 'signature',
          color: '#141414',
          bgcolor: 'rgba(255, 255, 255, 0.8)',
        },
      ],
    },
    {
      label: t('Require Seller Verification'),
      key: 'requireSellerVerification',
      type: 'checkbox',
    },
    {
      label: t('Reminder E-Mail'),
      type: 'expandFields',
      fields: [
        {
          label: t(
            'Should an email be sent automatically after a certain time has elapsed?'
          ),
          key: 'sendReminderEmail',
          type: 'checkbox',
        },
        {
          label: t(
            'Number of days the prospective buyer spends in the phase without change'
          ),
          type: 'number',
          key: 'reminderDaysAfter',
          decimalPlaces: 0,
        },
        {
          label: t('Subject'),
          key: 'emailReminderSubject',
          type: 'text',
        },
        {
          label: t('Attachments'),
          key: 'emailReminderAttachments',
          type: 'images',
          maxItems: 10,
          maxSizeKB: 5000,
        },
        {
          label: t('Content'),
          key: 'emailReminderContent',
          type: 'richTextEditor',
          textBlockType: 'block',
          allowSignature: true,
          signatureKey: 'signature',
          color: '#141414',
          bgcolor: 'rgba(255, 255, 255, 0.8)',
        },
      ],
    },
  ];

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t('Is required')),
    accessLevel: Yup.number().required(t('Is required')),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate ? `sales-object-levels/${data.id}` : `sales-object-levels`,
      method: isUpdate ? API_PATCH(data) : API_POST({ ...data, salesObjectId }),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  return (
    <ExoForm
      header={startData?.id ? t('Update Sales Level') : t('Create Sales Level')}
      fields={fields}
      startDataCollection={defaultStartData}
      onSubmit={handleSubmit}
      onCancel={onClose}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
    />
  );
};
